<template>
  <div class="row my-2">
    <div class="col-6">
      <h4>{{title}}</h4>
    </div>
    <div class="col-5">
      <div class="pt-item-panel">
        <slot />
      </div>
      <p><slot name="notes" /></p>
    </div>
    <div class="col-1"> </div>
  </div>
</template>


<script>
export default {
  name: 'ProgressTrackerPanel',
  props: {
    title: String
  }
}
</script>